import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import { ActionCreator } from 'redux';
import { IGetState } from '../../../../../../../types/types';
import { showSet } from '../../../store/actions/showSet';
import { processPerformanceAllow } from '../../../effects/processPerformanceAllow';
import { newPerformanceAllowedValueSet } from '../../../store/actions/newPerformanceAllowedValueSet';
import { root } from '../../../../../../../store/constants';
import { getUserPromoCode } from '../../../../../../../store/model/authUser/selectors/getUserPromoCode';
import { getUserPromoCodeShowed } from '../../../../../../../store/model/authUser/selectors/getUserPromoCodeShowed';
import {
    getUserManagedSubscriptions
} from '../../../../../../../store/model/authUser/selectors/getUserManagedSubscriptions';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import {
    quickStartGuideSetAction
} from '../../../../../main/navigationPanel/store/navigationPanel/actions/quickStartGuideSetAction';
import { EQuickStartGuideType } from '../../../../../main/navigationPanel/constants';

export const onAcceptCookie: ActionCreator<ThunkAction> = (
    isPerformanceAllowed: boolean
) => {
    const action = (dispatch: Dispatch, getState: IGetState) => {
        const state = getState();

        dispatch(segmentTrackAction(SegmentUserEvent.COOKIE_ACCEPT));

        dispatch(newPerformanceAllowedValueSet(isPerformanceAllowed));
        dispatch(processPerformanceAllow());

        dispatch(showSet(false));

        if (getAuthUser(state).anonym) return;

        if (!getUserPromoCodeShowed(state) && getUserPromoCode(state) && !getUserManagedSubscriptions(state).length) {
            root.App.controller.renderPromoCodePopup();
        } else {
            dispatch(quickStartGuideSetAction(EQuickStartGuideType.EFFICIENCY_JOURNEY_GUIDE));
        }
    };
    return action;
};
